import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';

export const fetchAllCarriers = createAsyncThunk('fetchAllCarriers', async () => {

})

export const updateCarrier = createAsyncThunk("updateCarrier", async (data) => {

})

export const addCarrier = createAsyncThunk("addCarrier", async (data) => {

})

export const removeCarrier = createAsyncThunk("removeCarrier", async (data) => {

})

const initialState = {
    allCarriers: [],
    loading: false,
    error: undefined,
}

const carriersSlice = createSlice({
    name: 'carrier',
    initialState,
    reducers: {
        resetIsSuccessAdded: (state) => {
            state.isSuccessAdded = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllCarriers.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAllCarriers.fulfilled, (state, {payload}) => {
                state.loading = false;
                state.allCarriers = payload;
            })
            .addCase(fetchAllCarriers.rejected, (state, action) => {
                state.error = action.payload;
                state.allCarriers = [];
                state.loading = false;
            })
            .addCase(updateCarrier.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateCarrier.fulfilled, (state, action) => {
                state.loading = false;
                state.error = undefined;
            })
            .addCase(updateCarrier.rejected, (state, action) => {
                state.error = action.payload;
                state.allCarriers = [];
                state.loading = false;
            })
            .addCase(addCarrier.pending, (state) => {
                state.loading = true;
                state.isSuccessAdded = false;
            })
            .addCase(addCarrier.fulfilled, (state, action) => {
                const arr = [...current(state.allCarriers)]
                arr.push(action.meta.arg)
                state.allCarriers = arr
                state.loading = false;
                state.isSuccessAdded = true;
            })
            .addCase(addCarrier.rejected, (state, action) => {
                state.error = action.payload;
                state.allCarriers = [];
                state.loading = false;
                state.isSuccessAdded = false;
            })
            .addCase(removeCarrier.pending, (state) => {
                state.loading = true;
            })
            .addCase(removeCarrier.fulfilled, (state, {payload}) => {
                const arr = [...current(state.allCarriers)]
                const index = arr.findIndex(i => i.uid === payload.uid)
                if (index !== -1) {
                    arr.splice(index, 1)
                    state.allCarriers = arr
                }
                state.loading = false;
            })
            .addCase(removeCarrier.rejected, (state, action) => {
                state.error = action.payload;
                state.allCarriers = [];
                state.loading = false;
            })
    }
});

export default carriersSlice.reducer;